module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bump-icon-276e5e347cd0a4d78a9c6222cdf228ae.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bump-icon.svg
// module id = 52VO
// module chunks = 24